import { IShowInformationParams } from 'src/models';
import Information from 'src/components/Information/Information';

export default {
    informationComponent: null,

    dispose() {
        if (this.informationComponent) {
            this.informationComponent.dispose();
        }
        this.informationComponent = null;
    },

    show(params: IShowInformationParams) {
        if (!this.informationComponent) {
            this.informationComponent = new Information({
                source: '<x-information></x-information>'
            });
            this.informationComponent.attach(document.body);
        }
        this.informationComponent.show(params)
    }
};
